import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthService from '../../services/auth-service';
import { useAuth } from '../../contexts/AuthContext';

export const AuthSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login, checkAuthStatus } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (token) {
      console.log('OAuth success: Token received', token);
      
      // Store the token using AuthService
      AuthService.setToken(token);
      
      // Notify auth context of successful login
      login();
      
      // Force a check of the auth status to ensure it's up to date
      checkAuthStatus();
      
      console.log('OAuth success: Token stored and auth context updated');
      
      // Redirect to profile page after a short delay
      const timer = setTimeout(() => {
        console.log('OAuth success: Redirecting to profile page');
        navigate('/profile');
      }, 2000);
      
      return () => clearTimeout(timer);
    } else {
      console.log('OAuth error: No token received');
      // If no token, redirect to login
      navigate('/oauth');
    }
  }, [navigate, searchParams, login, checkAuthStatus]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center p-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-foreground font-medium">
          Authentication successful! Redirecting to your profile...
        </p>
      </div>
    </div>
  );
};

export default AuthSuccess;